<template lang="pug">
.__pagination-paginator
  .inner
    ul
      li.prev(v-if='prev')
        ext-link.link(
          size='normal',
          :is='prevDisabled ? "div" : "ext-link"',
          @click='!prevDisabled ? $emit("input", current - 1) : ""'
        )
          slot(name='prev')
            span(v-html='prevText')
      li.page(v-for='item in items')
        .link(
          :class='disabled(item.number) ? "link-active" : ""'
        ) {{ item.text }}
      li.next(v-if='next')
        ext-link.link(
          size='normal',
          :is='nextDisabled ? "div" : "ext-link"',
          @click='!nextDisabled ? $emit("input", current + 1) : ""'
        )
          slot(name='next')
            span(v-html='nextText')
</template>

<script>
import ExtLink from '@/components/ext/Button.vue';

export default {
  components: {
    ExtLink,
  },
  props: {
    count: {
      type: Number,
      default: 0,
    },
    current: {
      type: Number,
      default: 0,
    },
    disableCurrent: {
      type: Boolean,
      default: true,
    },
    max: {
      type: Number,
      default: 0,
    },
    linkEmpty: {
      type: Boolean,
      default: true,
    },
    prev: {
      type: Boolean,
      default: true,
    },
    next: {
      type: Boolean,
      default: true,
    },
    prevText: {
      type: String,
      default: '&laquo;',
    },
    nextText: {
      type: String,
      default: '&raquo;',
    },
    urlParam: {
      type: String,
      default: 'page',
    },
    timeForQuestion: {
      type: Boolean,
      default: false,
    },
    isReatyToFinish: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    prevDisabled() {
      if (this.timeForQuestion) {
        return true;
      }
      return this.disabled(this.current - 1);
    },
    nextDisabled() {
      if (this.timeForQuestion && this.isReatyToFinish) {
        return true;
      }
      return this.disabled(this.current + 1);
    },
    items() {
      let av;
      if (this.max && this.count > this.max) {
        av = [];
        let half = Math.floor(
          (this.max - Math.min(3, this.count - this.max)) / 2,
        );
        let l = this.current - half;
        let r = this.current + half;
        if (l < 3) {
          l = 1;
          r = l + half * 2 + 1;
        }
        if (r > this.count - 2) {
          r = this.count;
          l = r - half * 2 - 1;
        }
        if (l > 2 && r < this.count - 1) {
          let size = r - l + 5;
          if (size > this.max) r = r - 1;
        }
        if (l > 1) {
          av.push({ v: 1, x: true });
        }
        if (l > 2) {
          av.push({ v: l - 1, x: false });
        }
        for (let i = l; i <= r; i++) {
          av.push({ v: i, x: true });
        }
        if (r < this.count - 1) {
          av.push({ v: r + 1, x: false });
        }
        if (r < this.count) {
          av.push({ v: this.count, x: true });
        }
      } else {
        av = new Array(this.count);
        for (let i = 0; i < av.length; i++) {
          av[i] = { v: i + 1, x: true };
        }
      }

      let list = [];
      for (let i = 0; i < av.length; i++) {
        let { v, x } = av[i];
        list.push({
          number: v,
          active: v == this.current,
          to: this.getLink(v),
          text: x ? v : '...',
        });
      }
      return list;
    },
  },
  methods: {
    disabled(value) {
      return (
        value < 1 ||
        value > this.count ||
        (this.disableCurrent && value === this.current)
      );
    },
    getLink(value) {
      return this.$route && !this.disabled(value)
        ? {
            ...this.$route,
            query: {
              ...this.$route.query,
              [this.urlParam]: value,
            },
          }
        : '';
    },
  },
};
</script>

<style lang="scss" scoped>
.__pagination-paginator {
  user-select: none;
  display: inline-block;

  .inner {
    display: flex;
    justify-content: center;

    ul {
      display: inline-block;
      white-space: nowrap;
      margin: 0;
      padding: 0;
      position: relative;
      list-style-type: none;
    }

    li {
      display: inline-block;
      vertical-align: middle;
      text-align: center;
      padding: 0 2px;
    }

    .link {
      display: inline-block;
      text-decoration: none;
      padding: 0;
      min-width: 2.5em;
      box-sizing: content-box;
      height: 2.5em;
      line-height: 2.5em;
      font-size: 14px;
      border-radius: 3px;

      &-active {
        color: #6e6bce !important;
        border-color: #6e6bce !important;
      }

      &:hover {
        text-decoration: none;
      }
    }

    div.link {
      border: 2px solid #8a899d;
      color: #8a899d;
      font-weight: bold;
    }

    .active + li > .link {
      border-left-width: 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// Paginator.vue?6befd5b4